import React from "react";
import "./Whytaxwithus.css";
import { Link } from "react-router-dom";
import { FaUsers, FaShieldAlt, FaLightbulb, FaHeadset } from "react-icons/fa";

const Whytaxwithus = () => {
  const features = [
    {
      icon: <FaUsers className="whytaxwithus-feature-icon" />,
      title: "Personalized Client Care",
      description:
        "We treat every client like family, tailoring tax solutions that respect your unique goals and circumstances with dedicated attention and customized strategies that align with your specific financial objectives.",
    },
    {
      icon: <FaShieldAlt className="whytaxwithus-feature-icon" />,
      title: "Ethics at the Core",
      description:
        "Our approach is rooted in honesty, fairness, and compliance — giving you peace of mind in every decision. We maintain the highest standards of integrity while navigating complex tax regulations and financial scenarios.",
    },
    {
      icon: <FaLightbulb className="whytaxwithus-feature-icon" />,
      title: "Forward-Thinking Strategies",
      description:
        "We anticipate tax trends and craft innovative approaches, ensuring you're always ahead, not just compliant. Our proactive planning identifies opportunities and mitigates risks before they impact your financial landscape.",
    },
    {
      icon: <FaHeadset className="whytaxwithus-feature-icon" />,
      title: "Always Accessible Support",
      description:
        "Our team is just a call away, ready to answer your questions and provide reliable guidance whenever you need it. We believe in building lasting relationships through consistent, responsive communication and ongoing support.",
    },
  ];

  return (
    <div className="whytaxwithus-section">
      <div className="whytaxwithus-header">
        <h2 className="whytaxwithus-title">
          Why <span className="whytaxwithus-highlight">Easy Tax Experts</span> Works Best for You
        </h2>
        <p className="whytaxwithus-subtitle">
          Partnering with us means choosing a dedicated team that values relationships as much as results.
          We simplify complexities, bring clarity to your finances, and ensure your growth journey feels
          effortless while delivering measurable financial advantages and long-term strategic partnerships.
        </p>
      </div>

      <div className="whytaxwithus-features-grid">
        {features.map((feature, index) => (
          <div key={index} className="whytaxwithus-feature-card">
            <div className="whytaxwithus-icon-container">{feature.icon}</div>
            <h3 className="whytaxwithus-feature-title">{feature.title}</h3>
            <p className="whytaxwithus-feature-description">
              {feature.description}
            </p>
            <div className="whytaxwithus-feature-hover"></div>
          </div>
        ))}
      </div>

      <div className="whytaxwithus-cta">
        <div className="whytaxwithus-cta-content">
          <h3>Ready to Experience the Difference?</h3>
          <p>
            Join thousands of satisfied clients who have transformed their
            financial journey with our expert guidance and personalized approach.
          </p>

          <Link to="/signup" className="whytaxwithus-cta-button">
            <span>Start Your Success Story</span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Whytaxwithus;
